
export default {
  data() {
    return {
      hasUpdate: false
    };
  },

  methods: {
    updateFound() {
      this.hasUpdate = true;
    },
    update() {
      window.location.reload(true);
    }
  },
  created() {
    this.$nuxt.$on("update-found", this.updateFound);
  },
  beforeDestroy() {
    this.$nuxt.$off("update-found", this.updateFound);
  }
};
